import PropTypes from "prop-types";
import {useState} from "react";
import classnames from "classnames";

import notSet from "shared/utils/notSet";

import dropdownArrow from 'shared/assets/images/Dropdown arrow Icon.svg';

import "./styles.scss";

function SelectInput({value, touched: propTouched, choices, required, className, onChange, onBlur, ...props}) {
    const [stateTouched, setTouched] = useState();
    const touched = propTouched || stateTouched;

    const optionsRender = choices.map(({value: itemValue, label}) =>
        <option value={itemValue} selected={itemValue === value}>{label}</option>,
    );

    const error = required && notSet(value) && "Required";

    return <>
        <div className={'SelectInput'}>
            <select
                className={classnames(className, {
                    "Valid": touched && !error,
                    "Error": touched && error,
                })}
                required={required}
                onChange={(...args) => {
                    onChange && onChange(...args);
                    setTouched(true);
                }}
                onBlur={(...args) => {
                    onBlur && onBlur(...args);
                    setTouched(true);
                }}
                {...props}
            >
                {optionsRender}
            </select>
            <img src={dropdownArrow} alt={"\\/"}/>
        </div>
        <div className={'ErrorList'}>
            {touched && error}&nbsp;
        </div>
    </>;
}

SelectInput.propTypes = {
    value: PropTypes.any,
    choices: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any,
            label: PropTypes.string.isRequired,
        }),
    ).isRequired,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
};

SelectInput.defaultProps = {
    required: false,
};

export default SelectInput;
